import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const NotfoundWrapper = styled(Box)`
  flex-direction: column;
  align-items: center;
  display: flex;
  justify-content: center;
  height: 80vh;
  gap: 24px;

  > h1 {
    font-size: 120px;
    line-height: normal;
    letter-spacing: normal;
  }
`;
